export function useThrottle(cb: () => void | any, delay = 100) {
    let interval: any = null;
    return () => {
        if (interval) return;
        interval = setTimeout(() => {
            interval = null;
            return cb();
        }, delay);
    }
}

// import { ref, Ref } from 'vue';

// export function useThrottle<T>(value: T, delay: number): Ref<T> {
//   const throttledValue = ref(value) as Ref<T>;
//   let lastExecuted = 0;

//   function updateValue(newValue: T) {
//     const now = Date.now();
//     if (now - lastExecuted >= delay) {
//       throttledValue.value = newValue;
//       lastExecuted = now;
//     }
//   }

//   return throttledValue;
// }
